module.exports = __webpack_public_path__ + "img/9788964371602.d9de1891.jpg";